import { DropdownOption } from 'components/dropdown/component'
import * as Flash from 'components/flash'
import { TRexIcon } from 'components/icons/t-rex'
import { TRexLargeIcon } from 'components/icons/t-rex-large'
import * as Validation from 'components/validation/validations'
import { RasaContext } from 'context'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import * as GA from 'google-analytics'
import React from 'react'
import * as GenerativeAI from 'shared_server_client/types/generative_ai'
import './_styles.scss'
import { ChatUtils } from '../shared/chatUtils'
import { PaperPlaneIcon } from "../../icons/paper-plane";
import { streamChatResponse, streamSourceResponse } from './data'
import { Loading } from 'components/loading'
import * as Constants from './constants'
import { DEFAULT_PROMPTS, FETCHING_SOURCE, Prompt, defaultTopicPropmts } from './constants'
import { isTruthy, tryParseJSON } from 'generic/utility'
import { Badge } from 'reactstrap'
import { SubscriptionTypes } from 'shared_server_client/constants'
import { Dataset } from 'generic/dataset'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { trim } from 'lodash'
import * as GenerateTextData from 'components/generate-text/data'

declare const RASA_IMAGE_API_ENDPOINT: string
const ModelTypeOptions: DropdownOption[] = [
  { description: 'default', key: '' },
  { description: 'mistral-tiny', key: 'mistral|mistral-tiny' },
  { description: 'mistral-small', key: 'mistral|mistral-small' },
  { description: 'openai-3.5', key: 'openai|gpt-3.5-turbo' },
  { description: 'openai-4.0', key: 'openai|gpt-4-1106-preview' },
]

interface State {
  aiChatSessions: any[],
  aiConfirmationType?: Constants.AIConfirmationType,
  activeCommunity: any,
  sources: any
  categories: GenerativeAI.Keyword[],
  chatInputPlaceholder: string,
  community: string,
  confirm: boolean,
  error?: string,
  found: boolean,
  input: string,
  isChatHistoryLoading: boolean,
  isLoading: boolean,
  message: string,
  newPrompts: GenerativeAI.ChatPrompt[],
  topics: string,
  person: any,
  sessionId: string,
  summary: string,
  showDefaultPrompt: boolean,
  showStreamLoader: boolean,
  streamMessage: string,
  suggestedSources: any,
  model: DropdownOption,
  prompt: string,
  prompts: GenerativeAI.ChatPrompt[],
  aiJsonResponse: string,
  pickStreamKey: boolean,
  currentStreamKey: string,
  showConfirmationPrompts: boolean,
  showsummaryStream: boolean,
  showsuggestedSourcesStream: boolean,
  showpromptStream: boolean,
  getSource: boolean,
  sidebarCollapsed: boolean,
  darkMode: boolean,
  quickActions: string[]
}

const newState: State = {
  aiChatSessions: [],
  aiConfirmationType: null,
  activeCommunity: {},
  sources: [],
  categories: [],
  chatInputPlaceholder: '',
  community: '',
  confirm: false,
  found: true,
  isChatHistoryLoading: false,
  isLoading: false,
  input: '',
  message: '',
  newPrompts: [],
  topics: '',
  person: {},
  sessionId: '',
  summary: '',
  aiJsonResponse: '',
  showDefaultPrompt: true,
  showStreamLoader: false,
  streamMessage: '',
  suggestedSources: [],
  model: ModelTypeOptions[0],
  prompt: '',
  prompts: [],
  pickStreamKey: false,
  currentStreamKey: '',
  showConfirmationPrompts: false,
  showsummaryStream: true,
  showsuggestedSourcesStream: true,
  showpromptStream: true,
  getSource: true,
  sidebarCollapsed: false,
  darkMode: false,
  quickActions: ['Find trending sources', 'Suggest source topics', 'Search by keyword', 'Get help with sourcing']
}

export class AnalyzeSourceContentComponentClass extends RasaReactComponent<any, State> {
  public chatEndRef;
  public chatInputRef;
  public static contextType = RasaContext;
  constructor(props: any) {
    super(props, 'communitySource', newState)
    this.sendMessage = this.sendMessage.bind(this)
    this.handleOnEnter = this.handleOnEnter.bind(this)
    this.chatEndRef = React.createRef()
    this.chatInputRef = React.createRef()
  }

  public componentDidMount = () => {
    this.context.user.init().then(({person, activeCommunity}) => {
      this.setState({
        activeCommunity,
        person,
        community: activeCommunity.communityId,
      }, () => {
        this.initialize()
      })
    })
  }

  public render = () => {
    return (
      <div className="rex-modern-wrapper">
        <div className={`rex-modern-sidebar ${this.state.sidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="rex-modern-sidebar-header">
            <div className="rex-modern-logo">
              <TRexIcon svgwidth="24" svgheight="24" />
              {!this.state.sidebarCollapsed && <span>t-rex</span>}
            </div>
            <div className="rex-modern-toggle" onClick={() => this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed })}>
              <i className={`fas ${this.state.sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`} />
            </div>
          </div>
          
          <div className="rex-modern-sessions">
            <div className="rex-modern-sessions-header">
              {!this.state.sidebarCollapsed && 'Previous Chats'}
              {this.state.prompts.length > 0 && (
                <div className="rex-modern-new-chat" onClick={this.clearChat}>
                  <i className="fas fa-plus" />
                </div>
              )}
            </div>
            
            <div className="rex-modern-sessions-list">
              {this.state.aiChatSessions.length ? (
                this.state.aiChatSessions.map((session, index) => (
                  <div 
                    key={index}
                    className={`rex-modern-session-item ${this.state.sessionId === session.session_id ? 'active' : ''}`}
                    onClick={() => this.getChatHistory(session.session_id)}
                    title={this.state.sidebarCollapsed ? session.title : ''}
                  >
                    <i className="fas fa-comment" />
                    {!this.state.sidebarCollapsed && <span>{session.title}</span>}
                  </div>
                ))
              ) : (
                <div className="rex-modern-session-item empty">
                  <i className="fas fa-comment" />
                  {!this.state.sidebarCollapsed && <span>No chat history</span>}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="rex-modern-main">
          {this.state.isChatHistoryLoading ? (
            <div className="rex-modern-loading">
              <Loading size="32" />
            </div>
          ) : (
            <>
              {/* Chat Header */}
              <div className="rex-chat-header">
                <div className="rex-header-info">
                  <TRexLargeIcon width="48" height="48" />
                  <div className="rex-header-text">
                    <h1>Source Assistant</h1>
                    <p>Your AI powered source discovery companion</p>
                  </div>
                </div>
              </div>
              
              <div className="rex-modern-chat" ref={this.chatEndRef}>
                {this.state.showDefaultPrompt && this.state.prompts.length === 0 && (
                  <div className="rex-modern-welcome">
                    <div className="rex-welcome-message">
                      <TRexIcon svgwidth="40" svgheight="40"/>
                      <div>
                        <h2>Hi there! I'm your t-rex 🦖</h2>
                        <p>I can help you discover amazing sources, find trending publications, and curate the perfect newsletter sources. What would you like to explore today?</p>
                      </div>
                    </div>
                    
                    <div className="rex-quick-actions">
                      <h3>Quick Actions</h3>
                      <div className="rex-action-grid">
                        {this.state.quickActions.map((action, index) => (
                          <button 
                            key={index} 
                            className="rex-action-btn"
                            onClick={() => {
                              this.setState({ message: action }, () => {
                                this.sendMessage()
                              })
                            }}
                          >
                            {action}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    {defaultTopicPropmts(this.state.topics).length > 0 && (
                      <div className="rex-suggested-prompts">
                        <h3>Suggested Questions</h3>
                        <div className="rex-prompt-list">
                          {defaultTopicPropmts(this.state.topics).map((prompt, index) => (
                            <button 
                              key={index} 
                              className="rex-prompt-btn"
                              onClick={() => this.executeDefaultPrompt(prompt)}
                            >
                              {prompt.content}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
                <div className="rex-modern-messages">
                  {this.state.prompts.map((prompt, index) => (
                    <div key={index} className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        {prompt.role === Constants.PROMPT_ROLE.USER ? (
                          ChatUtils.renderUserAvatar(this.state.person)
                        ) : (
                          <div className="rex-modern-bot-avatar">
                            <TRexIcon svgwidth="20" svgheight="20" />
                          </div>
                        )}
                      </div>
                      <div className="rex-modern-message-content">
                        {this.buildPrompt(prompt)}
                      </div>
                    </div>
                  ))}
                  
                  {this.state.sources.length > 0 && (
                    <div className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        <div className="rex-modern-bot-avatar">
                          <TRexIcon svgwidth="20" svgheight="20" />
                        </div>
                      </div>
                      <div className="rex-modern-message-content">
                        {this.buildSourcesPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.summary && this.state.showsummaryStream && (
                    <div className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        <div className="rex-modern-bot-avatar">
                          <TRexIcon svgwidth="20" svgheight="20" />
                        </div>
                      </div>
                      <div className="rex-modern-message-content">
                        {this.buildSummaryPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.suggestedSources.length > 0 && this.state.showsuggestedSourcesStream && (
                    <div className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        <div className="rex-modern-bot-avatar">
                          <TRexIcon svgwidth="20" svgheight="20" />
                        </div>
                      </div>
                      <div className="rex-modern-message-content">
                        {this.buildSuggestedSourcesPrompt(this.state)}
                      </div>
                    </div>
                  )}
                  
                  {this.state.prompt && (
                    <div className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        <div className="rex-modern-bot-avatar">
                          <TRexIcon svgwidth="20" svgheight="20" />
                        </div>
                      </div>
                      <div className="rex-modern-message-content">
                        <div className="rex-modern-message-text">
                          <p>{this.state.prompt}</p>
                        </div>
                        {this.state.showConfirmationPrompts && (
                          <div className="rex-modern-confirmation">
                            <button onClick={this.suggestContent} className="rex-modern-btn primary">
                              Yes
                            </button>
                            <button onClick={this.exploreMore} className="rex-modern-btn secondary">
                              {Constants.EXPLORE_MORE_PROMPT.content}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {this.state.showStreamLoader && (
                    <div className="rex-modern-message">
                      <div className="rex-modern-message-avatar">
                        <div className="rex-modern-bot-avatar">
                          <TRexIcon svgwidth="20" svgheight="20" />
                        </div>
                      </div>
                      <div className="rex-modern-message-content">
                        <div className="rex-modern-typing">
                          <Loading size="16" />
                          <span>t-rex is thinking...</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="rex-modern-input">
                <form onSubmit={(e) => { e.preventDefault(); this.sendMessage(); }}>
                  <div className="rex-modern-input-wrapper">
                    <input 
                      ref={this.chatInputRef}
                      type="text"
                      value={this.state.message}
                      onChange={(e) => this.setState({ message: e.target.value })}
                      onKeyDown={this.handleOnEnter}
                      placeholder={this.state.chatInputPlaceholder || 'Ask t-rex about source discovery...'}
                      className="rex-modern-input-field"
                    />
                    <button 
                      type="submit"
                      disabled={!this.state.message || this.state.message.length === 0}
                      className="rex-modern-send-btn"
                    >
                      <PaperPlaneIcon />
                    </button>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }

  private buildPrompt = (prompt) => {
    const promptJson = tryParseJSON(prompt.content)
    if (promptJson.summary) {
      return this.buildSummaryPrompt(promptJson)
    } else if (promptJson.sources && promptJson.sources.length > 0) {
      return this.buildSourcesPrompt(promptJson)
    } else if (promptJson.suggestedSources && promptJson.suggestedSources.length > 0) {
      return this.buildSuggestedSourcesPrompt(promptJson)
    } else {
      return this.buildMessagePrompt(prompt)
    }
  }

  private buildSuggestedSourcesPrompt = (prompt) => {
    return <div className="rex-modern-message-text">
      <h3>Do you want me to add {prompt.suggestedSources.length > 1 ? 'these Sources' : 'this Source'} to your Sources List?</h3>
      <div className='rex-modern-sources-grid'>
        {prompt.suggestedSources.map((source) => this.renderModernSource(source))}
      </div>
    </div>
  }

  private buildMessagePrompt = (prompt) => {
    prompt.content = prompt.content.includes(DEFAULT_PROMPTS[0].content) || prompt.content.includes(DEFAULT_PROMPTS[1].content) ?
      FETCHING_SOURCE : prompt.content
    return <div className="rex-modern-message-text">
      <p dangerouslySetInnerHTML={{__html: this.convertTextToLinks(prompt.content)}}></p>
    </div>
  }

  private buildSummaryPrompt = (prompt) => {
    if (this.state.getSource) {
      return
    }
    return <div className="rex-modern-message-text">
      <div className="rex-modern-summary">
        <h3>📝 t-rex's Summary</h3>
        <p>{prompt.summary}</p>
        {prompt.topics && prompt.topics.length > 0 && (
          <div className="rex-modern-topics">
            <h4>🏷️ Topics</h4>
            <div className="rex-modern-keywords">
              {prompt.topics.split(',').map((k: string, topicIndex: number) => (
                <Badge className="rex-modern-keyword" key={`keyword-${topicIndex}`}>
                  {k.trim()}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  }

  private buildSourcesPrompt = (prompt) => {
    return <div className="rex-modern-message-text">
      <h3>📰 Here are some sources I found for your newsletter:</h3>
      <div className='rex-modern-sources-grid'>
        {prompt.sources.map((source) => this.renderModernSource(source))}
      </div>
      <div className='rex-modern-actions'>
        <button onClick={this.suggestMoreContent} className="rex-modern-btn secondary">
          Show More
        </button>
        {prompt.sources.length > 1 && (
          <button 
            onClick={() => {
              this.logChatHistory(Constants.ADD_ALL_SOURCES_PROMPT, Constants.PROMPT_ROLE.USER)
              this.moveContentToSource(prompt.sources, 'bulk')
            }}
            className="rex-modern-btn primary"
          >
            Add All to Upcoming
          </button>
        )}
      </div>
    </div>
  }

  private renderModernSource = (source) => {
    return (
      <div className="rex-modern-source-card rex-compact-layout" key={source.source_url}>
        <div className="rex-source-icon rex-compact-image">
          <i className="fas fa-rss" />
        </div>
        <div className="rex-source-content rex-compact-content">
          <div className="rex-source-title">
            <a href={source.source_url} target="_blank" rel="noopener noreferrer">
              {source.name}
            </a>
          </div>
          <div className="rex-source-description">
            {source.site_name ? `Source: ${source.site_name}` : 'External Source'}
          </div>
          <div className="rex-source-actions">
            <button 
              className="rex-modern-btn primary small"
              onClick={() => {
                this.logChatHistory(`Add Source to Sources: "${source.name}"`, Constants.PROMPT_ROLE.USER)
                this.moveContentToSource(source, 'single')
              }}
            >
              Add to Upcoming
            </button>
          </div>
        </div>
      </div>
    )
  }

  private suggestContent = () => {
    if (this.state.summary) {
      this.setState({
        showStreamLoader: true,
        showConfirmationPrompts: false,
      })
      const payload = {
        topics: this.state.topics,
        summary: this.state.summary,
        session_id: this.state.sessionId,
      }
      streamSourceResponse(this.state.community, payload, this.updateSourcesResponse)
    } else {
      this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
    }
  }

  private suggestMoreContent = () => {
    this.setState({
      showStreamLoader: true,
    })
    this.logChatHistory(Constants.SHOW_MORE_SOURCES_PROMPT, Constants.PROMPT_ROLE.USER).then(() => {
      const payload = {
        session_id: this.state.sessionId,
      }
      streamSourceResponse(this.state.community, payload, this.updateSourcesResponse, true)
    }).catch(() => {
      this.setState({
        showStreamLoader: false,
      }, () => {
        this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
      })

    })
  }

  private exploreMore = () => {
    this.setState({
      prompt: '',
      prompts: [
        ...this.state.prompts,
        {
          role: Constants.PROMPT_ROLE.ASSISTANT,
          content: `${this.state.prompt}`,
        }
      ],
    }, () => {
      this.scrollToBottom()
    })
    // Don't auto-execute prompts - let user choose
    this.executeDefaultPrompt(Constants.EXPLORE_MORE_PROMPT)
  }

  private scrollToBottom = () => {
    this.chatEndRef.current.scrollTop = this.chatEndRef.current.scrollHeight;
  }

  protected validInput(): boolean {
    return Validation.validateForgivingUrl(this.state.input).valid || Validation.validateDomain(this.state.input).valid
  }

  protected handleOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.sendMessage()
    }
  }

  protected sendMessage = (message: string = "") => {
    if(message.includes(DEFAULT_PROMPTS[0].content) || message.includes(DEFAULT_PROMPTS[0].content)) {
      this.setState({
        getSource: true
      })
    } else {
      this.setState({
        getSource: false
      })
    }
    this.context.store.dispatch(GA.sendGa4Event(this.ga4Event(GA.EventNames.TRexQuestion)))
    this.setState({
      newPrompts: [
        ...this.state.newPrompts,
        {
          role: Constants.PROMPT_ROLE.USER,
          content: message ? message : this.state.message,
        }
      ],
      prompts:
        [
          ...this.state.prompts,
          {
            role: Constants.PROMPT_ROLE.USER,
            content: message ? message : this.state.message,
          }
        ],
      prompt: '',
      showConfirmationPrompts: false,
      message: '',
      showStreamLoader: true,
      showDefaultPrompt: false,
      chatInputPlaceholder: '',
    }, () => {
      streamChatResponse(this.state.community, {
        prompts: this.state.newPrompts,
        session_id: this.state.sessionId,
        requires_confirmation: this.state.aiConfirmationType !== null
      }, 'suggest-content', this.updateChatMessage)
      this.scrollToBottom()
    })
  }

  private executeDefaultPrompt = (prompt: Prompt) => {
    // if prompt has some placeholder it means it requires user's input
    if (prompt.placeholder) {
      this.setState({
        prompts:
          [
            ...this.state.prompts,
            {
              role: prompt.role,
              content: prompt.content,
            }
          ],
        newPrompts: [
          ...this.state.newPrompts,
          {
            role: prompt.role,
            content: prompt.content,
          }
        ],
        chatInputPlaceholder: prompt.placeholder,
        showDefaultPrompt: false,
      })
      this.chatInputRef.current.focus()
    } else {
      this.setState({
        showDefaultPrompt: false,
      })
      this.getSources()
    }
  }

  private getSources = () => {
    new Dataset()
      .loadCommunityDataset('communitySources', this.state.community)
      .then((response) => {
        if (!Array.isArray(response[0])) {
          return
        }
        const sortedObjects = [...response[0]].sort((a, b) => b.last_week_total - a.last_week_total)
        const topTwoObjects: any = sortedObjects.slice(0, 2)
        const sourceUrlsString = topTwoObjects
          .flatMap(obj => obj.source_url.split(',').map(url => url.trim()))
          .join('\n')
        this.sendMessage(`${DEFAULT_PROMPTS[0].content}\n${sourceUrlsString}`)
      })
  }


  private updateChatMessage: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if (!response) {
      this.setState({
        isSaving: false,
        newPrompts: [],
      })
    } else {
      if (response.done || response.error) {
        if (response.session_id) {
          this.setState({
            sessionId: response.session_id,
          })
        }
        let jsonString = response.message
        let aiJsonResponse = tryParseJSON(response.message)
        if (Object.keys(aiJsonResponse).length || this.state.aiJsonResponse) {
          if (Object.keys(aiJsonResponse).length === 0) {
            this.streamJson(response.message)
            jsonString = this.state.aiJsonResponse + response.message
            aiJsonResponse = tryParseJSON(jsonString)
          }
          if (aiJsonResponse && Object.keys(aiJsonResponse).length > 0) {
            if (isTruthy(aiJsonResponse.confirm) && this.state.aiConfirmationType !== null) {
              this.takeConfirmationAction(aiJsonResponse.confirm)
              return
            }
            if (aiJsonResponse.suggestedSources && aiJsonResponse.suggestedSources.length > 0) {
              this.setState({
                aiConfirmationType: Constants.AIConfirmationType.SOURCE_ADD,
                suggestedSources: aiJsonResponse.suggestedSources,
                showsuggestedSourcesStream: false,
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: jsonString,
                  }
                ],
                aiJsonResponse: '',
                showStreamLoader: false,
              })
            } else if (aiJsonResponse.source) {
              this.updateSourcesResponse(response)
            } else if (aiJsonResponse.summary) {
              let promptVal = [
                ...this.state.prompts,
                {
                  role: Constants.PROMPT_ROLE.ASSISTANT,
                  content: jsonString,
                }
              ]
              if (this.state.getSource) {
                promptVal = [
                  ...this.state.prompts
                ]
              }
              this.setState({
                prompts: promptVal,
                aiJsonResponse: '',
                aiConfirmationType: Constants.AIConfirmationType.SOURCE_SUGGESTION_REQUEST,
                summary: aiJsonResponse.summary,
                topics: aiJsonResponse.topics,
                showsummaryStream: false,
                showStreamLoader: false,
              }, () => {
                this.scrollToBottom()
                this.streamSummaryConfirmation()
              })
            } else if (aiJsonResponse.prompt) {
                this.setState({
                  prompts: [
                    ...this.state.prompts,
                    {
                      role: Constants.PROMPT_ROLE.ASSISTANT,
                      content: aiJsonResponse.prompt,
                    }
                  ],
                  aiJsonResponse: '',
                  showpromptStream: false,
                  showStreamLoader: false,
                })
              } else {
                this.setState({
                  aiJsonResponse: '',
                  showStreamLoader: false,
                })
                this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
              }
            } else {
              this.setState({
                aiJsonResponse: '',
                showStreamLoader: false,
              })
              this.streamText(Constants.REX_COULD_NOT_FIND_MSG)
            }
        } else {
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: this.state.prompt + response.message,
              }
            ],
            showStreamLoader: false,
          })
        }
        this.setState({
          isSaving: false,
          error: response.error,
          prompt: '',
          newPrompts: [],
        })
      } else {
        if (response.message) {
          const aiJsonResponse = tryParseJSON(response.message)
          if (aiJsonResponse.source) {
            this.updateSourcesResponse(response)
          } else if (trim(response.message).startsWith('{') || this.state.aiJsonResponse) {
            this.streamJson(response.message)
            this.setState({
              aiJsonResponse: this.state.aiJsonResponse + response.message,
              showStreamLoader: false,
            })
          } else {
            this.setState({
              prompt: this.state.prompt + response.message,
              showStreamLoader: false,
            })
          }
        }
      }
      this.scrollToBottom()
    }
  }

  private updateSourcesResponse: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if ( !response ) {
      this.setState({
        isSaving: false,
        showDefaultPrompt: false,
        showStreamLoader: false,
        chatInputPlaceholder: 'Ask t-rex about source discovery...',
        aiConfirmationType: null,
      })
    } else {
      const sourceJson = tryParseJSON(response.message)
      if (Object.keys(sourceJson).length) {
        if (response.done) {
          const sources = [
            ...this.state.sources,
            sourceJson.source,
          ]
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: JSON.stringify({
                  sources
                }),
              },
            ],
            sources: [],
          }, () => {
            this.scrollToBottom()
          })
        } else {
          this.setState({
            sources: [
              ...this.state.sources,
              sourceJson.source,
            ],
            isSaving: false,
            showStreamLoader: false,
          }, () => {
            this.scrollToBottom()
          })
        }
      } else {
        this.updateChatMessage(response)
      }
      this.scrollToBottom()
    }
  }

  private moveContentToSource = (payload: any, actionType: 'single' | 'bulk' = 'single') => {
    this.context.store.dispatch(GA.sendGa4Event(this.ga4Event(GA.EventNames.TRexAddSource)))
    this.setState({
      isLoading: true,
      showStreamLoader: true,
    })

    const processEntity = (data: any) => {
      return this.context.entityMetadata.getEntityObject('communitySource').then((entity) => {
        entity.setRecordId(this.state.activeCommunity.communityId, null)
        entity.data.name = data.name
        entity.data.community_id = this.state.activeCommunity.communityId
        entity.data.identifier = data.source_url
        entity.data.subscription_type_id = SubscriptionTypes.normal
        entity.data.type = data.source_type
        return entity.save()
      })
    }

    const processPayload = () => {
      if (Array.isArray(payload)) {
        return Promise.all(payload.map((item) => processEntity(item)))
      } else {
        return processEntity(payload)
      }
    }

    return processPayload()
      .then(() => {
        this.setState({
          isLoading: false,
          suggestedSources: [],
          aiConfirmationType: null,
          showStreamLoader: false,
        })
        
        // Use shared utility for success messages
        const sourceIds = Array.isArray(payload) ? payload.map(s => s.source_url) : [payload.source_url]
        const successMessage = ChatUtils.getSuccessMessage(sourceIds, actionType, 'source')
        this.streamText(successMessage)
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          showStreamLoader: false,
        })
        this.streamText('❌ Sorry, I encountered an error while adding the source. Please try again.')
      })
  }


  private initialize = () => {
    Promise.all([
      this.getChatSessions(),
      this.getTopics(),
      this.getSources(),
    ])
  }

  private getTopics = () => {
    return GenerateTextData.getTopics(this.state.community)
      .then((topics) => {
        if ( topics ) {
          this.setState({
            showDefaultPrompt: true,
            topics: topics.join(','),
          })
        }
      })
  }

  private getChatSessions = () => {
    return new Dataset().loadCommunityDataset('aiChatSessions', this.state.community, []).then((aiChatSessions) => {
        if (aiChatSessions[0].length) {
          this.setState({
            aiChatSessions: aiChatSessions[0],
          })
        }
      })
  }

  private getChatHistory = (sessionId) => {
    this.setState({
      sessionId,
      isChatHistoryLoading: true,
    })
    return new Dataset().loadCommunityDataset('aiChatHistory', this.state.community, [{param: 'sessionId', value: sessionId}]).then((aiChatHistory) => {
      if (aiChatHistory[0].length) {
        const prompts = aiChatHistory[0].filter((prompt) => prompt.source !== Constants.CHATSOURCE.FULL_SOURCES_LIST &&
          (prompt.source === Constants.CHATSOURCE.RECOMMENDATION_ENGINE || JSON.parse(prompt.options).role !== Constants.PROMPT_ROLE.SYSTEM)).map((prompt)=> {
          const jsonContent = tryParseJSON(prompt.prompt)
          let content = jsonContent.prompt ? jsonContent.prompt : prompt.prompt
          const options = tryParseJSON(prompt.options)
          if (prompt.source === Constants.CHATSOURCE.RECOMMENDATION_ENGINE) {
            const sources = tryParseJSON(prompt.prompt)
            content = JSON.stringify({
              sources,
            })

          }
          return {
            role: options.role || Constants.PROMPT_ROLE.ASSISTANT,
            content,
          }
        })
        this.setState({
          isChatHistoryLoading: false,
          prompts,
        }, () => {
          this.scrollToBottom()
        })
      }
    }).catch(() => {
      this.setState({
        isChatHistoryLoading: false,
      })
      this.context.store.dispatch(Flash.showFlashMessage('Unable to fetch chat history. Please try again.'))
    })
  }

  private takeConfirmationAction = (confirm) => {
    if (!isTruthy(confirm)) {
      return
    }
    this.setState({
      prompt: '',
    })
    if (this.state.aiConfirmationType === Constants.AIConfirmationType.SOURCE_ADD) {
      const actionType: 'single' | 'bulk' = this.state.suggestedSources.length > 1 ? 'bulk' : 'single'
      this.moveContentToSource(this.state.suggestedSources, actionType)
    } else if (this.state.aiConfirmationType === Constants.AIConfirmationType.SOURCE_SUGGESTION_REQUEST) {
      this.suggestContent()
    }
  }

  private streamJson = (jsonStream: string) => {
    jsonStream = jsonStream
    const pickTriggers = [
      "{",
      " {",
      " { ",
      "{\n",
      "{\"",
      ".\",",
      "?\",",
      "?\",\n",
      ".\",\n",
    ]
    const ignoreStreamData = [
      ...pickTriggers,
      " ",
      '"',
      "",
      "\n",
      "\":",
      '":',
      '"}',
      "\"}",
      " \"",
      ' "',
    ]
    const replaceStreamData = [{
      key: "?\",",
      value: "?",
    }, {
      key: "?\",\n",
      value: "?",
    }]
    if (pickTriggers.includes(jsonStream)) {
      this.setState({
        pickStreamKey: true,
      })
    } else if (ignoreStreamData.includes(jsonStream)) {
      return
    } else {
      if (this.state.pickStreamKey) {
        this.setState({
          ...this.state,
          [`show${this.state.pickStreamKey}Stream`]: true,
          currentStreamKey: jsonStream,
          pickStreamKey: false,
        })
      } else {
        if (this.state.currentStreamKey !== 'prompt' || this.state.aiConfirmationType === null) {
          // replace stream Data
          replaceStreamData.forEach((replaceData) => {
            jsonStream = jsonStream.replace(replaceData.key, replaceData.value)
          })
          this.setState({
            ...this.state,
            showStreamLoader: false,
            [this.state.currentStreamKey]: this.state[this.state.currentStreamKey] + jsonStream,
          }, () => {
            this.scrollToBottom()
          })
        }
      }
    }
  }

  private delay = (ms: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms)
    })
  }

  private streamSummaryConfirmation = () => {
    if (this.state.getSource) {
      this.scrollToBottom()
      this.suggestContent()
    } else {
      this.streamText(FETCHING_SOURCE, true).then(() => {
        this.scrollToBottom()
        this.suggestContent()
      })
    }
  }

  private convertTextToLinks = (text: string): string => {
    // Regex pattern to match URLs
    const urlPattern = /(\bhttps?:\/\/[^\s/$.?#].[^\s]*)/gi;
    // Regex pattern to match emails
    const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

    // Convert URLs to hyperlinks
    let result = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>');
    // Convert emails to mailto links
    result = result.replace(emailPattern, '<a href="mailto:$1">$1</a>');

    return result;
  }


  private streamText =  (text, addToPrompt = true) => {
    const TEXT_STREAM_DELAY = 100
    const words = text.split(' ')
    this.logChatHistory(text)
    return new Promise((resolve, reject) => {
      return words.forEach((word, index) => {
        this.delay(TEXT_STREAM_DELAY * (index + 1)).then(() => {
          if (index === words.length - 1) {
            resolve(true)
            if (addToPrompt) {
              this.setState({
                prompt: '',
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: `${this.state.prompt} ${word}`,
                  }
                ],
              }, () => {
                this.scrollToBottom()
              })
            } else {
              this.setState({
                prompt: `${this.state.prompt} ${word}`,
              }, () => {
                this.scrollToBottom()
              })
            }
          } else {
            this.setState({
              prompt: `${this.state.prompt} ${word}`,
            }, () => {
              this.scrollToBottom()
            })
          }
        })
      })
    })
  }
  private logChatHistory = (message, role = Constants.PROMPT_ROLE.ASSISTANT) => {
    // This is a fire and forget method we don't care if this fails.
    try {
      const serverUrl = AjaxWrapper.getServerUrl()
      if (!serverUrl) {
        // AjaxWrapper not initialized, skipping chat history logging
        return Promise.resolve()
      }
      const url: string = `${serverUrl}/ai/${this.state.community}/log-chat-history`
      return AjaxWrapper.ajax(url, HttpMethod.POST, {
        session_id: this.state.sessionId,
        prompt: message,
        role,
      })
      .catch((error) => {
        // Error logging chat history
      })
    } catch (error) {
      // Error accessing AjaxWrapper
      return Promise.resolve()
    }
  }
  private clearChat = () => {
    this.setState({
      ...newState,
      aiChatSessions: this.state.aiChatSessions,
      activeCommunity: this.state.activeCommunity,
      community: this.state.community,
      model: this.state.model,
      getSource: false
    }, () => {
      this.getChatSessions()
    })
  }

  private ga4Event = (eventName: string): GA.Event4 => {
    return {
      name: eventName,
      payload: {
        source: 't-rex-chat',
      },
    }
  }
}

